import { render, staticRenderFns } from "./BuyerCounterpartySidebar.vue?vue&type=template&id=8cfe6320&scoped=true&"
import script from "./BuyerCounterpartySidebar.vue?vue&type=script&lang=js&"
export * from "./BuyerCounterpartySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfe6320",
  null
  
)

export default component.exports